/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-06-15 11:44:49
 * @LastEditors: K
 * @LastEditTime: 2022-07-26 09:30:27
 */
import { RecipeStatus } from './recipe'
import * as R from './registration'
import { Registration } from './registration'
import * as T from './treatment'
import { Treatment } from './treatment'

export type PaymentStatus =
  | RecipeStatus.ToSettle
  | RecipeStatus.Settled
  | RecipeStatus.Returned

export interface Payment {
  id: string
  amount: number
  registration: Registration
  treatment: Treatment
}

export interface PaymentRegistrationParams {
  realPayAmount?: string
  receivePayAmount?: string
  payMethod?: PayMethod
}

// XJ("01", "现金"), ZFB("03", "支付宝"), WX("04", "微信"), DWJZ("04", "单位记账"),
// YL("05", "银联"), HYKKK("06", "会员卡扣款"), JHZF("02", "聚合支付")
// ,POSD("08","智能POSD支付"),QT("99", "其他"),SFKZF("98","市民卡支付");
export enum PayMethod {
  Unknown = 0,
  Cash = 1,
  Alipay = 3,
  Weipay = 4,
  UnionPay = 5,
  Juhe = 2,
}

export const PayMethods = [
  PayMethod.Cash,
  PayMethod.Alipay,
  PayMethod.Weipay,
  PayMethod.UnionPay,
  PayMethod.Juhe,
]

export function getPayMethodName(method: PayMethod): string {
  switch (method) {
    case PayMethod.Cash:
      return '现金'
    case PayMethod.Alipay:
      return '支付宝'
    case PayMethod.Weipay:
      return '微信'
    case PayMethod.UnionPay:
      return '银联'
    case PayMethod.Juhe:
      return '聚合支付'
  }
  return ''
}

export function fromJson(
  data: { paymentId?: number } & Record<string, never>
): Payment {
  const id = data.paymentId?.toString() || ''
  const registration = R.fromJson(data.registration)
  const treatment = T.fromJson(data.treatment)
  return {
    id: id ? id : registration.id,
    amount: data.amount,
    registration,
    treatment,
  }
}
